import React from 'react';
import StaticConfetti from '@assets/icons/confetti-static.svg';
import StaticMoneyConfetti from '@assets/icons/confetti-static-money.svg';
import { ConfettiProps } from './confetti';
import { useTheme } from '@/contexts/theme-context';

export const Confetti: React.FC<ConfettiProps> = ({ type }) => {
  const theme = useTheme();

  const Icon = type === 'money' ? StaticMoneyConfetti : StaticConfetti;
  return <Icon accentFill={theme.colors.accent} fill={theme.colors.primary} />;
};
